/** Marks AI-sourced content that no teacher has approved yet. The one meaning of violet.
 * Any component that shows AI output must include one of these until the teacher acts. */
import { useTranslation } from "react-i18next";

export type DraftKind = "draft" | "cached" | "edited";

export function DraftChip({ kind = "draft" }: { kind?: DraftKind }) {
  const { t } = useTranslation();
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-dashed px-2 py-0.5 text-xs font-medium"
      style={{ borderColor: "var(--draft)", color: "var(--draft)" }}
    >
      <span aria-hidden>✎</span>
      {t(`draft.${kind}`)}
    </span>
  );
}

/** Wrap AI content: dashed violet border, chip in the corner. */
export function DraftFrame({ kind = "draft", children }: { kind?: DraftKind; children: React.ReactNode }) {
  return (
    <div className="relative rounded-[var(--radius-card)] border border-dashed p-4" style={{ borderColor: "var(--draft)" }}>
      <div className="absolute -top-3 left-3 bg-[color:var(--bg)] px-1">
        <DraftChip kind={kind} />
      </div>
      {children}
    </div>
  );
}
